export default {"src":"/_next/static/media/1-cnn-logo.6aeed0a0.svg","height":22,"width":46};